<!-- 活跃资源top5 -->
<template>
    <div class="top-five-active-resource">
        <div class="top-five-active-resource-title">
            <div class="name">活跃资源top5</div>
        </div>
        <div class="top-five-active-resource-tab">
            <div v-for="tab in tabs" :key="tab.id" :class="tabName == tab.id ? 'is-select' : ''" @click="selectBtn(tab.id)">
                {{ tab.name }}
            </div>
        </div>
        <div class="top-five-active-resource-list">
            <div class="box" v-for="item in regionResourceHomeList " key="item.id">
                <img :src=grturl(item.fileExt) alt="" />
                <div>
                    <span class="title">{{ item.title }}</span>
                    <span class="subtitle">资源预览量：{{ item.previews }}</span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: "top-five-active-resource",
    components: {},
    props: {
        regionId: {
            type: String,
            default: ''
        },

    },
    data() {
        return {
            tabName: 31308,
            url: "https://tearesearch.iclass30.com/regionResource/resource/regionResourceHomeList",
            regionResourceHomeList: [],
            tabs: [
                { id: '31308', name: '课例' },
                { id: '31306', name: '微课' },
                { id: '31302', name: '课件' },
                { id: '31304', name: '教案' },
                { id: '31305', name: '导学案' }
            ]
        }
    },
    mounted() {
        this.getregionResourceHomeList();
    }
    ,
    methods: {
        grturl(type) {
            if (type == 'mp4') {
                return require("@/assets/images/qingxudataboard/shiping.png")
            } else if (type == 'pptx' || type == 'ppx') {
                return require("@/assets/images/qingxudataboard/ppt.png")
            }
            else if (type == 'doc' || type == 'docx') {
                return require("@/assets/images/qingxudataboard/word.png")
            } else {
                return require("@/assets/images/qingxudataboard/yasuobao.png")
            }
        },
        /**
         * @name 切换
         */
        selectBtn(type) {

            if (this.tabName == type) {
                return;
            }
            this.tabName = type;
            //重新请求接口
            this.getregionResourceHomeList();

        },
        getregionResourceHomeList() {
            this.regionResourceHomeLis = []
            axios.get('https://tearesearch.iclass30.com/regionResource/resource/regionResourceHomeList', {
                params: {
                    regionId: this.regionId,
                    orderType: 1,
                    typeCode: this.tabName,
                    page: 1,
                    limit: 5
                }
            })
                .then(response => {
                    this.regionResourceHomeList = response.data.data.rows;
                })
                .catch(error => {
                    console.error(error);
                    // 在这里处理错误
                });
        }
    },

}
</script>
<style lang="scss" scoped>
.top-five-active-resource {
    width: 100%;
    height: 560px;
    margin-top: 25px;
    background: rgba(9, 19, 66, 0.94);
    border-radius: 0px 0px 4px 4px;

    .top-five-active-resource-title {
        background: url("~@/assets/images/qingxudataboard/title-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 13px 0 18px;

        .name {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

    .top-five-active-resource-tab {
        padding: 20px 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & div {
            // height: 20px;
            padding: 2px 0;
            font-size: 16px;
            font-family: Microsoft YaHei;
            color: #FFFFFF;
            cursor: pointer;

            &:hover {
                color: #38FFF3;
                font-weight: bold;
            }
        }

        & span {
            width: 1px;
            height: 15px;
            margin: 0 10px;
            opacity: .3;
            background-color: #38FFF3;
        }

        .is-select {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #38FFF3;
            border-bottom: 2px solid transparent;
            -webkit-border-image: url("~@/assets/images/qingxudataboard/is_selected.png") 0 0 2 0 stretch;
            /* Safari 5 and older */
            -o-border-image: url("~@/assets/images/qingxudataboard/is_selected.png") 0 0 2 0 stretch;
            /* Opera */
            border-image: url("~@/assets/images/qingxudataboard/is_selected.png") 0 0 2 0 stretch;
        }
    }

    .top-five-active-resource-list {
        margin-top: 5px;
        padding: 0 10px;


    }

    .box {
        text-align: start;
        width: 100%;
        height: 70px;
        margin-bottom: 23px;
        background: #102764;
        border-radius: 10px;

        & img {
            float: left;
            width: 50px;
            height: 50px;
            margin-top: 10px;
            margin-left: 10px;
        }

        & div {
            float: right;
            width: calc(100% - 70px);
            height: 70px;
            margin-bottom: 23px;
            background: #102764;
            border-radius: 10px;
        }
    }

    .box::after {
        content: "";
        display: table;
        clear: both;
    }

    .title {
        display: block;
        font-size: 16px;
        width: calc(100% - 20px);
        font-family: Microsoft YaHei;
        color: #FFFFFF;
        white-space: nowrap;
        /* 防止文本换行 */
        overflow: hidden;
        /* 隐藏超出元素宽度的文本 */
        text-overflow: ellipsis;
        /* 显示省略号 */
        margin: 10px 0;
        word-break: break-all;
    }

    .subtitle {
        font-size: 12px;
        font-family: Microsoft YaHei;
        color: #FFFFFF;
        opacity: .6;
    }
}
</style>